(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider', '$urlRouterProvider'];

    function stateConfig($stateProvider, $stickyStateProvider, $urlRouterProvider ) {
        $stateProvider
        .state('prem-disc', {
            // parent: 'entity',
            parent: 'app',
            url: '/prem-disc?page&sort&search',
            sticky: true,
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.premDisc.home.title',
                title: 'Prem Disc'
            },
            views: {
                // 'content@': {
                'prem-disc@': {
                    templateUrl: 'app/entities/prem-disc/prem-discs.html',
                    controller: 'PremDiscController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('premDisc');
                    $translatePartialLoader.addPart('priceType');
                    $translatePartialLoader.addPart('wtUnitType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('prem-disc-detail', {
            // parent: 'entity',
            parent: 'app',
            url: '/prem-disc/{id}',
            sticky: true,
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ccsTrApp.premDisc.detail.title',
                title: 'Detail'
            },
            views: {
                // 'content@': {
                'prem-disc-detail@': {
                    templateUrl: 'app/entities/prem-disc/prem-disc-detail.html',
                    controller: 'PremDiscDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('premDisc');
                    $translatePartialLoader.addPart('priceType');
                    $translatePartialLoader.addPart('wtUnitType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PremDisc', function($stateParams, PremDisc) {
                    return PremDisc.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'prem-disc',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('prem-disc-detail.edit', {
            // parent: 'prem-disc-detail',
            parent: 'app',
            // url: '/detail/edit',
            url: '/prem-disc/detail/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/prem-disc/prem-disc-dialog.html',
                    controller: 'PremDiscDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PremDisc', function(PremDisc) {
                            return PremDisc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('prem-disc.new', {
            // parent: 'prem-disc',
            parent: 'app',
            // url: '/new',
            url: '/prem-disc/new',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/prem-disc/prem-disc-dialog.html',
                    controller: 'PremDiscDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                createdOn: null,
                                createdBy: null,
                                modifiedOn: null,
                                modifiedBy: null,
                                grade: null,
                                amount: null,
                                amountType: null,
                                wtUnitType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('prem-disc', null, { reload: true });
                }, function() {
                    $state.go('prem-disc');
                });
            }]
        })
        .state('prem-disc.edit', {
            // parent: 'prem-disc',
            parent: 'app',
            // url: '/{id}/edit',
            url: '/prem-disc/{id}/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/prem-disc/prem-disc-dialog.html',
                    controller: 'PremDiscDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PremDisc', function(PremDisc) {
                            return PremDisc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('prem-disc', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('prem-disc.delete', {
            // parent: 'prem-disc',
            parent: 'app',
            // url: '/{id}/delete',
            url: '/prem-disc/{id}/delete',
            sticky: false,
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/prem-disc/prem-disc-delete-dialog.html',
                    controller: 'PremDiscDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PremDisc', function(PremDisc) {
                            return PremDisc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('prem-disc', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });

        $stickyStateProvider.enableDebug( true );
        
    }

})();
